module.exports = __webpack_public_path__ + "img/inverse-osmosis-text.7c3bfc47.svg";